import React from "react";
import { formatDp, formatThousands, formatMaxDp } from "lib/numberFormat";
import { isJa } from "app/i18n/i18n";

export function formatRating(rating = "") {
  if (rating === "Buy") return <span className="text-success">{rating}</span>;
  if (rating === "Reduce") return <span className="text-primary">{rating}</span>;

  return rating;
}

export function formatPrice(price = "", ccy) {
  if (!price || price === "(null)") return "N/A";
  let ret = price;

  if (ccy !== "JPY") {
    ret = formatDp(price, 2);
  } else {
    ret = formatThousands(price);
  }
  return ret;
}

export function formatDate(date = "") {
  if (date.length > 10) return date.substr(0, 10);
}

export function parseMarketCap(cap = "") {
  try {
    cap = formatMaxDp(cap, 2) || "";
  } catch (err) {
    console.error("Cannot parse market cap of :", cap);
  }
  return cap;
}

export function companyLink(companyName, companyTicker) {
  let ja = isJa() ? "-JA" : "";
  let compWithTickerName = companyName + " (" + companyTicker + ")";
  return `/Home?CompanyWithTicker${ja}=` + encodeWithBrackets(compWithTickerName);
}

export function analystLink(analyst) {
  return "/Analyst?Analyst=" + analyst;
}

export function encodeWithBrackets(str) {
  return encodeURIComponent(str)
      .replace(/[(]/g, '%28')
      .replace(/[)]/g, '%29');
}
